/** The learner's bundle shelf. One request, one grid. */

import { learn } from '../api';
import { BundleTile, TileGrid } from '../components/Bits';
import { Empty, ErrorNote, Loading, PageTitle } from '../components/Chrome';
import { ds } from '../ds';
import { useRouter } from '../router';
import { plural } from '../theme';
import { useLoad } from '../useLoad';

export default function Bundles() {
  const { Button } = ds();
  const { navigate } = useRouter();
  const { data, error, loading } = useLoad(() => learn.bundles(), 'Could not load your bundles.');

  if (error) return <ErrorNote>{error}</ErrorNote>;
  if (!data) return loading ? <Loading /> : null;

  return (
    <>
      <PageTitle title="Bundles." meta={plural(data.bundles.length, 'bundle')} />

      {data.bundles.length === 0 ? (
        <Empty line="No bundle has been assigned to you.">
          <Button variant="secondary" size="sm" onClick={() => navigate('/catalogue')}>
            Browse catalogue
          </Button>
        </Empty>
      ) : (
        <TileGrid>
          {data.bundles.map((b) => (
            <BundleTile key={b.id} bundle={b} />
          ))}
        </TileGrid>
      )}
    </>
  );
}
